import { Component, ViewChild, Input, Output, EventEmitter, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { BaseControlComponent } from "../base/base-control.component";
import { HttpCommonService, LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { CheckableSettings, TreeItemLookup, TreeViewComponent } from "@progress/kendo-angular-treeview";
import { Observable, of } from "rxjs";
import { SelectorService } from "../base/selector.service";

@Component({
  selector: "tree-lookup",
  templateUrl: "./lookup-tree.component.html",
  styleUrls: ["./lookup-tree.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LookupTreeComponent extends BaseControlComponent<any> {
  _dataList: any[] = [];
  @Input() get dataList(): any[] {
    return this._dataList;
  }
  @Input() hasCheckBoxLookUpTree: boolean = true;
  set dataList(value: any[]) {
    this._dataList = value;
  }

  isshow: boolean;
  filterdList: any[] = [];
  openToggle: boolean = false;
  top: string;
  left: string;
  right: string;
  isInside: boolean;

  @Input() isModal: boolean;
  @Input() class: string;
  public keys: string[] = [];
  public children = (dataItem: any): Observable<any[]> => of(this.dataList.filter((x) => x[this.parentIdName] === dataItem[this.valueFieldName]));
  public hasChildren = (dataItem: any): boolean => this.dataList.some((x) => x[this.parentIdName] === dataItem[this.valueFieldName]);
  get customWidth() {
    return document.getElementById("inputbox").clientWidth - 30;
  }
  ngAfterViewChecked() {
    super.ngAfterViewChecked();
    if (this.f[this.name].value || (this.f[this.name].value !== undefined && this.f[this.name].value !== null)) {
      this.isshow = true;
    }
  }
  show() {
    this.isshow = !this.isshow;
  }
  focusFunction() {
    this.isshow = true;
    if (document.getElementById(this.name)) document.getElementById(this.name).focus();
  }
  focusOutFunction() {
    if (!this.f[this.name].value || this.f[this.name].value === "") {
      this.isshow = false;
    }
  }
  @Input() isPaging: boolean = false;
  @Input() autocomplete: string = "off";
  @Input() ParentId: number;
  searchValue: string = "";
  isFiltering: boolean = false;
  @ViewChild(TreeViewComponent, { static: false }) public treeview: TreeViewComponent;
  _currentValue: number;
  @Output() currentValueChange: EventEmitter<number> = new EventEmitter<number>();
  @Input()
  set currentValue(value: number) {
    this._currentValue = value;
  }
  get currentValue(): number {
    if (!this.filterdList || this.filterdList.length <= 0) this.filterdList = this.dataList;
    if (
      !this._currentValue ||
      (this.name && this.SelectRow && this.f[this.name].value && this.f[this.name].value !== this.SelectRow[this.valueFieldName])
    )
      this.setCurrentValue();

    return this._currentValue;
  }
  SelectRow: any;
  @Input() apiName: string;
  @Input() systemName: string;
  @Input() category: string;
  @Input() valueFieldName: string;
  @Input() textFieldName: string;
  @Input() textColumnsName: string;
  _paretnIdValue: number;
  _parentIdName: string;

  @Input()
  get parentIdName(): string {
    return this._parentIdName;
  }
  set parentIdName(value: string) {
    this._parentIdName = value;
  }
  loading = false;
  @Output() onRowsSelected = new EventEmitter<any>();
  @Output() onRowSelected = new EventEmitter<any>();
  @Input() filterKey: string;
  @Input() checkedKeys: any[] = [];
  public _checkedKeys: any[] = [];
  public get checkableSettings(): CheckableSettings {
    return {
      checkChildren: true,
      checkParents: true,
      enabled: true,
      mode: this.multiple ? "multiple" : "single",
      checkOnClick: true,
    };
  }

  ngOnInit() {
    this.multiple = !this.multiple && this.parentIdName && this.filterKey === "multi";
    super.ngOnInit();
    this._checkedKeys.push(...this.checkedKeys);
    window.addEventListener("scroll", this.scroll, true); //third parameter
    this.refreshData();
  }
  async refreshData() {
    this.loading = true;
    if (this.apiName) {
      if (!this.dataList || this.dataList.length <= 0) {
        await this._httpCommonService
          .getList(this.apiName)
          .pipe(takeUntil(this.ngUnsubscribe))
          .toPromise()
          .then((data: any[]) => {
            this.dataList = data;
            this.filterdList = data;
            this.loading = false;
            this.setCurrentValue();
          });
      }
    }
  }
  constructor(
    private _httpCommonService: HttpCommonService,
    private lookupservice: LookupService,
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef
  ) {
    super(selectorService, cd);
  }
  setCurrentValue() {
    if (!this.SelectRow && this.f[this.name].value) {
      if (this.filterdList && this.filterdList.length > 0) {
        this.SelectRow = this.filterdList.find((x) => x[this.valueFieldName] === this.f[this.name].value);
        this._currentValue = this.SelectRow[this.textFieldName];
        this.onRowSelected.emit(this.SelectRow);
        this.valueChange.emit(this.currentValue);
      }
    } else if (this.SelectRow && !this.isFiltering) {
      this._currentValue = this.SelectRow[this.textFieldName];
    }
  }
  public onkeyup(value: string): void {
    this.filterdList = this.search(this.dataList, value);
  }
  public search(items: any[], term: string): any[] {
    return items.reduce((acc, item) => {
      if (this.contains(item.Title, term)) {
        acc.push(item);
      } else if (item.items && item.items.length > 0) {
        const newItems = this.search(item.items, term);

        if (newItems.length > 0) {
          acc.push({ Title: item.Title, items: newItems });
        }
      }

      return acc;
    }, []);
  }
  public isExpanded = (dataItem: any, index: string) => {
    return this.keys.indexOf(index) > -1;
  };

  public handleCollapse(node) {
    this.keys = this.keys.filter((k) => k !== node.index);
  }

  public handleExpand(node) {
    this.keys = this.keys.concat(node.index);
  }
  public contains(text: string, term: string): boolean {
    return text.toLowerCase().indexOf(term.toLowerCase()) >= 0;
  }

  showClear(): boolean {
    return (
      this.name &&
      ((this.f[this.name] && this.f[this.name].value != null && this.f[this.name].value !== undefined && this.f[this.name].value > 0) ||
        this.searchValue.length > 0) &&
      !this.disabled
    );
  }
  clearValue() {
    this.isshow = false;
    this._checkedKeys = [];
    this._checkedKeys.push(...this.checkedKeys);
    if (this.f[this.name].value && !this.disabled) this.f[this.name].markAsDirty();
    this.f[this.name].setValue(undefined);
    this.valueChange.emit(this.f[this.name].value);
    this._currentValue = undefined;
    this.searchValue = "";
    this.SelectRow = undefined;
    this.refreshData();
  }
  setChildren(value: any, list: any[]) {
    this.children(value).forEach((x) => {
      x.forEach((xx) => {
        if (!list.some((f) => f[this.valueFieldName] === xx[this.valueFieldName])) list.push(xx);
        if (this.hasChildren(xx)) this.setChildren(xx, list);
      });
    });
  }
  openPopover() {
    if (this.openToggle && this.multiple && this._checkedKeys && this._checkedKeys.length > 0) {
      let list: any[] = [];
      this._checkedKeys.forEach((x) => {
        let seleted = this.filterdList.find((f) => f[this.valueFieldName] === x);
        if (!list.some((f) => f[this.valueFieldName] === x)) list.push(seleted);
        if (this.hasChildren(seleted)) this.setChildren(seleted, list);
      });
      this.valueChangeByApiName.emit({ data: list, apiName: this.apiName });
    }
    this.openToggle = !this.openToggle;
    //this.top = 'auto';
  }
  onResize(event) {
    if (this.openToggle) {
      setTimeout(() => {
        this.cd.markForCheck();
      }, 100);
    }
  }
  scroll = (event): void => {
    const currentPos = this.top;
    setTimeout(() => {
      this.cd.markForCheck();
      if (currentPos !== this.top) this.closePopOver();
    }, 100);
  };
  closePopOver() {
    if (this.openToggle) {
      this.openToggle = false;
      this.top = "auto";
      this.cd.markForCheck();
    }
  }
  closeout() {
    if (this.openToggle) {
      this.openToggle = false;
      // this.top = "auto";
      if (this.multiple && this._checkedKeys && this._checkedKeys.length > 0) {
        let list: any[] = [];
        this._checkedKeys.forEach((x) => {
          let seleted = this.filterdList.find((f) => f[this.valueFieldName] === x);
          if (!list.some((f) => f[this.valueFieldName] === x)) list.push(seleted);
          if (this.hasChildren(seleted)) this.setChildren(seleted, list);
        });
        this.valueChangeByApiName.emit({ data: list, apiName: this.apiName });
      }
      this.cd.markForCheck();
    }
  }
  inside() {
    this.isInside = true;
  }
  handleSelection($event) {
    if ($event.dataItem && !this.dataList.some((x) => x[this.parentIdName] === $event.dataItem[this.valueFieldName])) {
      this.SelectRow = $event.dataItem;
      this.isFiltering = false;
      if (this.SelectRow) this._currentValue = this.SelectRow[this.textFieldName];
      this.currentValueChange.emit(this.SelectRow[this.valueFieldName]);
      if (this.f[this.name].value !== this.SelectRow[this.valueFieldName] && !this.disabled) this.f[this.name].markAsDirty();
      this.f[this.name].setValue(this.SelectRow[this.valueFieldName]);
      this.onRowSelected.emit(this.SelectRow);
      this.valueChange.emit(this.currentValue);
      this.valueChangeByApiName.emit({ data: this.SelectRow, apiName: this.apiName });
      if (this.openToggle) this.closePopOver();
    }
  }
}
